import { render, staticRenderFns } from "./Appheader.vue?vue&type=template&id=01ceba0b"
import script from "./Appheader.vue?vue&type=script&lang=js"
export * from "./Appheader.vue?vue&type=script&lang=js"
import style0 from "./Appheader.vue?vue&type=style&index=0&id=01ceba0b&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports